import io from 'socket.io-client'
import {SOCKET_STATUSES} from '../const/const';

class Socket {
    static getInstance() {
        if (!this.instance) {
            this.instance = new Socket();
        }
        return this.instance;
    }

    setDomain(domain = process.env.REACT_APP_DOMAIN) {
        this.domain = domain;
        return Socket.getInstance();
    }

    startSocket() {
        this.socket = io(this.domain);
    }

    subscribeArchiveLoaded(callback) {
        this.socket.on(SOCKET_STATUSES.archive_loaded, callback);
    }

    subscribeArchiveUnpacked(callback) {
        this.socket.on(SOCKET_STATUSES.archive_unpacked, callback);
    }

    subscribeArchiveDone(callback) {
        this.socket.on(SOCKET_STATUSES.done, callback);
    }
}

export default Socket;
